import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

if (!supabaseUrl || !supabaseAnonKey) {
  const message = `Supabase configuration missing. Ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set.`;

  // In production, we fail loudly to prevent "Zombie App" state.
  if (import.meta.env.PROD) {
    throw new Error(`[FATAL] ${message}`);
  }

  console.warn(`[DEV ONLY] ${message} Using placeholders.`);
}

export const supabase = createClient(
  supabaseUrl || "https://placeholder.supabase.co",
  supabaseAnonKey ||
    (() => {
      throw new Error("VITE_SUPABASE_ANON_KEY is not set");
    })(),
);

// Protocol: Provide reachability for E2E Testing (Reactive Security Verification)
// WARNING: Ensure import.meta.env.DEV is only true in development/test environments.
if (import.meta.env.DEV) {
  (window as unknown as { supabase: unknown }).supabase = supabase;
}
